import styled from "styled-components";

export const Image = styled.img`
  height: 24px;
  width: 24px;
`;
